import { render, staticRenderFns } from "./TestReserve.vue?vue&type=template&id=40d96052"
import script from "./TestReserve.vue?vue&type=script&lang=js"
export * from "./TestReserve.vue?vue&type=script&lang=js"
import style0 from "./TestReserve.vue?vue&type=style&index=0&id=40d96052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports